<template>
  <div class="expertContainer" id="expertContainer">
    <el-card>
      <div class="header">
        <div class="goback" @click="goBack">
          <img src="../assets/goback.png" alt />
          <span>返回</span>
        </div>
        <div class="mark">
          <img src="../assets/location.png" alt />
          <span>专家服务-请教专家</span>
        </div>
      </div>
      <div class="main">
        <!-- <div class="type">
          <div class="attr">问题类型：</div>
          <el-select v-model="type" placeholder="请选择">
            <el-option v-for="item in options" :key="item.type" :value="item.type"></el-option>
          </el-select>
        </div>-->
        <div class="title">
          <div class="attr">问题标题：</div>
          <el-input
            type="text"
            placeholder="请输入问题标题"
            v-model="title"
            maxlength="50"
            show-word-limit
          ></el-input>
        </div>
        <div class="desc">
          <div class="attr">问题描述：</div>
          <el-input
            type="textarea"
            placeholder="填写内容详情，方便了解"
            v-model="content"
            maxlength="199"
            show-word-limit
            resize="none"
            rows="8"
          ></el-input>
        </div>
        <div class="pic">
          <div class="attr">
            <div>图片上传：</div>
            <div class="prompt">(最多上传9张)</div>
          </div>
          <div style="width:90%;">
            <el-upload
              action="http://192.168.0.118:18091/self/upload"
              list-type="picture-card"
              :on-change="handleChange"
              :on-remove="handleRemove"
              :auto-upload="false"
              :limit="maxPic"
              ref="upload"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
          </div>
        </div>
        <div class="select">
          <div class="attr">选择专家：</div>
          <el-select v-model="expertid" placeholder="请选择" @change="onChange">
            <el-option
              v-for="item in options1"
              :key="item.type"
              :label="item.type"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="footer">
        <el-button @click="reset">重置</el-button>
        <el-button type="primary" @click="submit">立即提交</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import { APIMAP } from "../constants/apiConstants";
import { getServerData } from "../utils/fetchData";
import { mapState } from "vuex";

export default {
  data() {
    return {
      options: [],
      title: "",
      content: "",
      maxPic: 9,
      expertid: "",
      imgURL: [],
      options1: [{ type: "PM2.5专家小组", value: 71 }],
      expert: "",
    };
  },
  // created() {},
  methods: {
    // 文件状态改变时的钩子，添加文件、上传成功和上传失败时都会被调用
    async handleChange(file, fileList) {
      console.log(file, fileList);
      if (fileList.length === 0) return;
      const params = {};
      params.file = file.raw;
      params.pid = this.userInfo.platformid;
      params.type = "1";
      console.log("图片上传的参数", params);
      try {
        const res = await getServerData(APIMAP.UPLOAD, params, "post", 0, true);
        console.log("图片上传返回的结果", res);
        const { url } = res;
        const obj = {};
        obj.id = file.uid;
        obj.url = url;
        this.imgURL.push(obj);
      } catch (error) {
        console.log(error);
      }
    },
    // 移除文件
    handleRemove(file, fileList) {
      console.log("remove", file, fileList);
      this.imgURL = this.imgURL.filter((item) => item.id !== file.uid);
    },
    goBack() {
      this.$router.go(-1);
    },
    onChange(val) {
      // console.log(val);
      this.expert = this.options1.filter((item) => item.value === val)[0].type;
    },
    // 提交提问
    async submit() {
      const {
        title,
        content,
        expert,
        imgURL,
        expertid,
        userInfo: { gid, platformid },
      } = this;
      const emptyArr = [];
      imgURL.forEach((item) => {
        emptyArr.push(item.url);
      });
      const params = {};
      params.title = title;
      params.content = content;
      params.imgurl = emptyArr.join("|");
      params.expertid = expertid;
      params.expert = expert;
      params.username = this.userInfo.rolename;
      params.uid = gid;
      params.pid = platformid;
      console.log("请求参数", params);
      // 判断是否有参数为空
      const arr = Object.keys(params);
      for (var i = 0; i < arr.length; i++) {
        if (params[arr[i]] === "") {
          return this.$message.error("请填写完所有的内容");
        }
      }
      try {
        const res = await getServerData(APIMAP.EXPERTASK, params, "post");
        console.log("提交结果", res);
        this.$message.success("提交成功");
        // 清空参数
        this.clear();
        this.$router.push({
          path: "/myProblem",
        });
      } catch (error) {
        console.log(error);
      }
    },
    // 重置表单
    async reset() {
      const res = await this.$confirm("是否重置表单?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).catch((err) => err);
      if (res === "confirm") {
        this.clear();
        this.$message.success("表单重置成功");
      }
    },
    clear() {
      this.$refs.upload.clearFiles();
      this.type = "";
      this.title = "";
      this.expertid = "";
      this.expert = "";
      this.content = "";
      this.imgURL = [];
    },
  },
  computed: {
    ...mapState(["userInfo"]),
  },
};
</script>

<style lang='less' scoped>
.expertContainer {
  width: 100%;
  padding: 24px 26px 0;
  .el-card {
    width: 100%;
    min-width: 1133px;
    margin-bottom: 40px;
    .header {
      display: flex;
      align-items: center;
      height: 86px;
      border-bottom: 1px solid #e2e5ec;
      .goback {
        display: flex;
        align-items: center;
        width: 58px;
        height: 22px;
        font-size: 16px;
        font-family: PingFangSC, PingFangSC-Regular;
        color: #99a9ba;
        line-height: 22px;
        margin-right: 23px;
        cursor: pointer;
        img {
          margin-right: 8px;
        }
      }
      .mark {
        display: flex;
        align-items: center;
        font-size: 16px;
        font-family: PingFangSC, PingFangSC-Regular;
        color: #99a9ba;
        img {
          margin-right: 7px;
        }
      }
    }
    .main {
      border-bottom: 1px solid #e2e5ec;
      margin-top: 30px;
      .type,
      .title,
      .select {
        display: flex;
        align-items: center;
        margin-bottom: 24px;
        .attr {
          width: 92px;
          height: 22px;
          font-size: 16px;
          font-family: PingFangSC, PingFangSC-Medium;
          font-weight: 600;
          color: #394259;
          line-height: 22px;
          margin-right: 10px;
        }
      }
      .desc,
      .pic {
        display: flex;
        margin-bottom: 24px;
        .attr {
          width: 92px;
          height: 50px;
          font-size: 16px;
          font-family: PingFangSC, PingFangSC-Medium;
          font-weight: 600;
          color: #394259;
          margin-right: 10px;
          .prompt {
            opacity: 0.72;
            font-size: 12px;
            font-family: PingFangSC, PingFangSC-Regular;
            color: #838997;
            line-height: 21px;
            margin-top: 10px;
          }
        }
      }
      .select {
        margin-bottom: 80px;
      }
    }
    .footer {
      height: 106px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .el-button {
        width: 150px;
      }
    }
  }
}
</style>
